import { Button } from "@mui/material";
import { useState } from "react";
import { adminApi } from "../../../api/admin/admin";
import { pushAlert } from "../../alerts/alertSlice";
import { useDispatch } from "react-redux";

const LoginAsUser = () => {
  const dispatch = useDispatch();  
  const [email, setEmail] = useState("");
    
    const loginClick = async () => {
      if(!email) return;

      const resp = await adminApi.loginAsUser(email);
      if(!resp.ok) {
        dispatch(pushAlert({
          message: resp.err,
          type: "danger",
          delay: 5000,
        }))
        return;
      };

      window.location.href = "/profile";
    }

    return (
    <div className="p-5 border rounded-xl mx-5 flex flex-wrap justify-center items-center gap-5" style={{minHeight: "200px"}}>
      <div className="text-2xl">Login as user </div>
      <div className="flex gap-5 items-center  justify-center flex-wrap">
        <input onChange={(e) => setEmail(e.target.value)} value={email} placeholder="email" className="p-2 border rounded-xl"/>
        
        <Button
            variant="contained"
            sx={{
                color: "white",
                bgcolor: "#059669",
                fontSize: "0.7rem",
                padding: "5px 10px",
                ":hover": {
                    bgcolor: "#065f46",
                },
            }}
            onClick={loginClick}
        >
            Login
        </Button>
      </div>
      </div>
  )
}

export default LoginAsUser